import { combineReducers } from 'redux';

import authReducer from './authReducer';

import userReducer from './userReducer';
import FormReducer from './formReducer';
import errorReducer from './errorReducer';
import errorReducer1 from './errorReducer1';
import paymentReducer from './paymentReducer';
import responseReducer from './responseReducer';
import analyticsReducer from './analyticsReducer';

export default combineReducers({
  auth: authReducer,
  form: FormReducer,
  response: responseReducer,
  user: userReducer,
  payment: paymentReducer,
  builderErrors: errorReducer,
  errors: errorReducer1,
  analytics: analyticsReducer,
});
